import React, { useContext } from "react";
import { ContentSection } from "sprint-common-web";

import { SystemPlatformListingContext } from "./context/SystemPlatformListingContext";

export const BuzzIdSection = (): JSX.Element => {
    const { buzzId, isLoading } = useContext(SystemPlatformListingContext);

    return (
        <ContentSection testId="buzz-id-section" header="Buzz Id" isLoading={isLoading}>
            {buzzId}
        </ContentSection>
    );
};
